"use client"

import PropTypes from "prop-types"
import { RiArrowRightCircleLine } from "react-icons/ri"

import { Tag } from "@/components/Tag"
import theme from "@/theme"

import { Button, ButtonTextTagContainer } from "./styled"

/**
 * Button with a tag and text for customer page
 *
 * @param {object} props
 * @param {string} props.text - text displayed in the button
 * @param {string} props.tagText - text displayed inside the tag
 * @param {function} props.onClick - onClick callback
 * @param {string} props.link - link to redirect to
 * @returns JSX.Element
 */
export const TagButton = ({ text, tagText, onClick, link, ...props }) => {
  return (
    <Button href={link} handleClick={onClick} {...props}>
      <ButtonTextTagContainer>
        {text}
        {tagText && <Tag text={tagText} />}
      </ButtonTextTagContainer>
      <RiArrowRightCircleLine size={theme.iconSizes.normal} />
    </Button>
  )
}

TagButton.propTypes = {
  /* text displayed in the button */
  text: PropTypes.string,
  /* text displayed inside the tag */
  tagText: PropTypes.string,
  /* onClick callback */
  onClick: PropTypes.func,
  /* link to redirect to */
  link: PropTypes.string,
}
